/**
 * @Author: Zero
 * @Date: 2025-05-07 11:15:17
 * @Explain: 获取针对业务配置的信息
 */
import type { Effect } from 'umi';
// api
import { contactManageApi } from '@/api';
// utils
import { getActionType } from '@/utils/common/redux';
// type
import { ReducersEnum } from './connect.d';

export type BusinessControlConfigType = {
  /** 联系人导出/导出中心支持by业务的开关配置，默认关，不可查看导出历史 */
  isExport: boolean;
  //   请求状态 init 请求前 （loading） success 请求成功 fail 请求失败
  requestStatus: 'init' | 'success' | 'fail';
};
/** 参数声明 */
export type BusinessControlConfigState = {
  /** 业务级别控制配置信息 */
  businessControlConfig: BusinessControlConfigType;
};

export type ModelType = {
  namespace: string;
  state: BusinessControlConfigState;
  reducers: {
    /** 更新业务级别控制配置信息 */
    setBusinessControlConfig: (
      state: BusinessControlConfigState,
      action: { payload: any },
    ) => any;
  };
  effects: {
    getBusinessControlConfig: Effect;
  };
};

const BusinessControlConfigModel: ModelType = {
  namespace: 'BusinessControlConfigModel',
  state: {
    /** 业务级别控制配置信息 */
    businessControlConfig: {
      isExport: false,
      requestStatus: 'init',
    },
  },
  reducers: {
    /** 更新业务级别控制配置信息 */
    setBusinessControlConfig(state, action) {
      return {
        ...state,
        businessControlConfig: {
          ...state.businessControlConfig,
          ...action.payload,
        },
      };
    },
  },
  effects: {
    // 获取业务级别控制配置信息
    *getBusinessControlConfig({ payload }, { call, put }): any {
      const result = yield call(contactManageApi.getCheckPermission, payload);
      const { code, data } = result;
      if (code === 0) {
        yield put({
          type: getActionType(ReducersEnum.SET_BUSINESS_CONTROL_CONFIG),
          payload: {
            ...data,
            requestStatus: 'success',
          },
        });
      } else {
        yield put({
          type: getActionType(ReducersEnum.SET_BUSINESS_CONTROL_CONFIG),
          payload: {
            isExport: false,
            requestStatus: 'fail',
          },
        });
      }
    },
  },
};

export default BusinessControlConfigModel;
